import * as React from 'react';
import { TimePicker } from '@app/src/components/TimePicker';
import { Field } from '@app/src/components/Field';

export const RenderTimePicker = ({
  label,
  type,
  portionWidth,
  meta: { error, touched },
  date,
  input,
  ...rest
}) => {
  let isError = (error && touched) ? error : '';
  const today = new Date().getDate();
  const daySelected = date ? date.split('/')[0] : '';
  return(
    <Field label={label} portionWidth={portionWidth} errorMessage={isError} {...rest}>
      <TimePicker
        type={type}
        time={input.value}
        uncontrolled
        {...input}
        {...rest}
        error={!!isError}
        currentTime={Number(daySelected) === today ? true : false}
        />
    </Field>
  );
}
